import { render, staticRenderFns } from "./MyDashboard.vue?vue&type=template&id=25735fe8&scoped=true&"
import script from "./MyDashboard.vue?vue&type=script&lang=js&"
export * from "./MyDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MyDashboard.vue?vue&type=style&index=0&id=25735fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25735fe8",
  null
  
)

export default component.exports